import axiosInstance from "../config/axiosIntance";
import { GetDevicesByIdServiceResponseType } from "../types";

type Params = {
  token: string;
  ciamId: string;
  serviceProvider: string;
  username: string;
  deviceId: string;
};

export const getDevicesByIdService = async ({
  token,
  serviceProvider,
  ciamId,
  username,
  deviceId
}: Params): Promise<GetDevicesByIdServiceResponseType> => {
  const dataFetched = await axiosInstance.get<GetDevicesByIdServiceResponseType>(
    `/devices/${ciamId}/devices/${deviceId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        serviceProvider,
        username
      }
    }
  );

  return dataFetched.data;
};
